import { Chip } from "@mui/material";
import React from "react";
import { formatString } from "../../../common";
import { useComponentSelection } from "../../Hooks/useComponentSelection";
import { ChipColor, ChipModel, ChipVariant } from "../../Models/ChipModel";
import IComponentProps from "../IComponentProps";
import getComponentLayout from "../Table/getComponentLayout";

const getChipVariant = (variant?: ChipVariant): "filled" | "outlined" | undefined => {
  if (variant === undefined) return undefined;
  switch (variant) {
    case ChipVariant.Filled:
      return "filled";
    case ChipVariant.Outlined:
      return "outlined";
    default:
      return undefined;
  }
};

const getChipColor = (color?: ChipColor): "default" | "primary" | "secondary" | "success" | "error" | "warning" | "info" | undefined => {
  if (color === undefined) return undefined;
  switch (color) {
    case ChipColor.Default:
      return "default";
    case ChipColor.Primary:
      return "primary";
    case ChipColor.Secondary:
      return "secondary";
    case ChipColor.Success:
      return "success";
    case ChipColor.Error:
      return "error";
    case ChipColor.Warning:
      return "warning";
    case ChipColor.Info:
      return "info";
    default:
      return undefined;
  }
};

const ChipComponent: React.FC<IComponentProps<ChipModel>> = ({ component, context, componentPath = [] }) => {
  const componentLayoutSx = getComponentLayout(component);
  // ToDo: Monitor variable scope changes if Label is expression-based
  const label = formatString(component.Label, context.VariableScope);
  const variant = getChipVariant(component.Variant);
  const color = getChipColor(component.Color);

  const selectionProps = useComponentSelection({ component, componentPath });

  return <Chip label={label} variant={variant} color={color} sx={componentLayoutSx} {...selectionProps} />;
};

export default ChipComponent;
